import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { FormsService } from 'src/app/services/forms.service';
import { GoalsService } from 'src/app/services/goals.service';
import { getCookie } from 'src/app/utils/get-cookie';
import {
  setObjectiveEntrepreneurshipAction,
  setObjectiveMarriageAction,
  setObjectiveOthersAction,
  setObjectivePropertyAction,
  setObjectiveRetirementAction,
  setObjectiveTripsAction,
  setObjectiveVehiclesAction,
} from './store/objective.actions';
import {
  getObjectiveEntrepreneurshipSelectorsState,
  getObjectiveMarriageSelectorsState,
  getObjectiveOthersSelectorsState,
  getObjectivePropertySelectorsState,
  getObjectiveRetirementSelectorsState,
  getObjectiveTripsSelectorsState,
  getObjectiveVehiclesSelectorsState,
} from './store/objective.selectors';
import {
  IObjectivesFormState,
  IObjectivesRetirementFormState
} from './store/objective.state';

@Component({
  selector: 'app-objective',
  templateUrl: './objective.component.html',
  styleUrls: ['./objective.component.scss'],
})
export class ObjectiveComponent implements OnInit {
  
  selectedGoals: number[] = [];
  formsId: number = 0

  checkRetirementState$: Observable<any>;
  checkTripsState$: Observable<any>;
  checkPropertyState$: Observable<any>;
  checkVehiclesState$: Observable<any>;
  checkEntrepreneurshipState$: Observable<any>;
  checkMarriageState$: Observable<any>;
  checkOthersState$: Observable<any>;

  isLoading = true;
  savingGoals = false;

  dataRetirementState: IObjectivesRetirementFormState;
  dataTripsState: IObjectivesFormState;
  dataPropertyState: IObjectivesFormState;
  dataVehiclesState: IObjectivesFormState;
  dataEntrepreneurshipState: IObjectivesFormState;
  dataMarriageState: IObjectivesFormState;
  dataOthersState: IObjectivesFormState;

  enableButton: boolean;

  constructor(
    private store: Store,
    private readonly formsService: FormsService,
    private readonly goalsService: GoalsService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.formsId = Number(getCookie('formsId'))
    this.loadSelectedGoals()
    this.getStates();
  }

  loadSelectedGoals(){
    this.isLoading = true
    this.goalsService.getSelectedGoals(this.formsId).subscribe((res: any)=> {
      this.selectedGoals = res.data || []
      this.isLoading = false
    })
  }

  toggleGoal(goalId: number): void {
    if (this.selectedGoals.includes(goalId)) {
      this.selectedGoals = this.selectedGoals.filter((id) => id !== goalId);
    } else {
      this.selectedGoals.push(goalId);
    }
  }

  saveGoals(): void {
    this.savingGoals = true
    this.goalsService.createGoals(this.formsId, this.selectedGoals).subscribe(() => {
      const goalActions = {
        1: () => this.selectRetirement(1),
        2: () => this.selectTrips(2),
        3: () => this.selectProperty(3),
        4: () => this.selectVehicles(4),
        5: () => this.selectEntrepreneurship(5),
        6: () => this.selectMarriage(6),
        7: () => this.selectOthers(7),
      };
    
      // Percorre os selectedGoals e chama a função correspondente
      this.selectedGoals.forEach((goalId) => {
        if (goalActions[goalId]) {
          goalActions[goalId](); // Chama a função correspondente ao ID
        }
      });
      this.router.navigate(['/objective-forms'])
    
    });

  }

  getStates() {
    this.checkRetirementState$ = this.store.select(
      getObjectiveRetirementSelectorsState
    );
    this.checkRetirementState$.subscribe((value) => {
      this.dataRetirementState = value;
      if (this.dataRetirementState.isSelected) {
      }
    });

    this.checkTripsState$ = this.store.select(getObjectiveTripsSelectorsState);
    this.checkTripsState$.subscribe((value) => {
      this.dataTripsState = value;
    });

    this.checkPropertyState$ = this.store.select(
      getObjectivePropertySelectorsState
    );
    this.checkPropertyState$.subscribe((value) => {
      this.dataPropertyState = value;
    });

    this.checkVehiclesState$ = this.store.select(
      getObjectiveVehiclesSelectorsState
    );
    this.checkVehiclesState$.subscribe((value) => {
      this.dataVehiclesState = value;
    });

    this.checkEntrepreneurshipState$ = this.store.select(
      getObjectiveEntrepreneurshipSelectorsState
    );
    this.checkEntrepreneurshipState$.subscribe((value) => {
      this.dataEntrepreneurshipState = value;
    });

    this.checkMarriageState$ = this.store.select(
      getObjectiveMarriageSelectorsState
    );
    this.checkMarriageState$.subscribe((value) => {
      this.dataMarriageState = value;
    });

    this.checkOthersState$ = this.store.select(
      getObjectiveOthersSelectorsState
    );
    this.checkOthersState$.subscribe((value) => {
      this.dataOthersState = value;
    });
    this.checkContinueButton();
  }

  checkContinueButton() {
    this.enableButton =
      this.dataRetirementState.isSelected ||
      this.dataTripsState.isSelected ||
      this.dataPropertyState.isSelected ||
      this.dataVehiclesState.isSelected ||
      this.dataEntrepreneurshipState.isSelected ||
      this.dataMarriageState.isSelected ||
      this.dataOthersState.isSelected
        ? false
        : true;
  }

  //Retirement
  selectRetirement(id: number): void {
    this.dataRetirementState = {
      ...this.dataRetirementState,
      isSelected: !this.dataRetirementState.isSelected,
    };

    this.store.dispatch(setObjectiveRetirementAction(this.dataRetirementState));
    this.enableButton = this.dataRetirementState.isSelected ? false : true;

    this.checkContinueButton();
  }

  //Trips
  selectTrips(id: number): void {
    this.dataTripsState = {
      ...this.dataTripsState,
      isSelected: !this.dataTripsState.isSelected,
    };

    this.store.dispatch(setObjectiveTripsAction(this.dataTripsState));
    this.enableButton = this.dataTripsState.isSelected ? false : true;

    this.checkContinueButton();
  }

  //Property
  selectProperty(id: number): void {
    this.dataPropertyState = {
      ...this.dataPropertyState,
      isSelected: !this.dataPropertyState.isSelected,
    };

    this.store.dispatch(setObjectivePropertyAction(this.dataPropertyState));

    this.checkContinueButton();
  }

  //Vehicles
  selectVehicles(id: number): void {
    this.dataVehiclesState = {
      ...this.dataVehiclesState,
      isSelected: !this.dataVehiclesState.isSelected,
    };

    this.store.dispatch(setObjectiveVehiclesAction(this.dataVehiclesState));

    this.checkContinueButton();
  }

  //Entrepreneurship
  selectEntrepreneurship(id: number): void {
    this.dataEntrepreneurshipState = {
      ...this.dataEntrepreneurshipState,
      isSelected: !this.dataEntrepreneurshipState.isSelected,
    };

    this.store.dispatch(
      setObjectiveEntrepreneurshipAction(this.dataEntrepreneurshipState)
    );

    this.checkContinueButton();
  }

  //Marriage
  selectMarriage(id: number): void {
    this.dataMarriageState = {
      ...this.dataMarriageState,
      isSelected: !this.dataMarriageState.isSelected,
    };

    this.store.dispatch(setObjectiveMarriageAction(this.dataMarriageState));

    this.checkContinueButton();
  }

  //Other
  selectOthers(id: number): void {
    this.dataOthersState = {
      ...this.dataOthersState,
      isSelected: !this.dataOthersState.isSelected,
    };

    this.store.dispatch(setObjectiveOthersAction(this.dataOthersState));
    this.checkContinueButton();
  }


}
